<template>
  <NavBar></NavBar>
  <div class="historique">
    <section class="timeline">
      <ul>
        <div class="ligne">
          <div class="texte-ligne">2022</div>
        </div>
        <li>
          <div>
            <time>05/2022</time>
            <div class="discovery">
              <h1>Création de l'asso</h1>
              <p>Art'EFREI vient d'être créer ! 🤩</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>06/2022</time>
            <div class="discovery">
              <h1>1er Bureau Restreint</h1>
              <p>🔶 Président : Sylvain MIGEON 🔶</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>08/2022</time>
            <div class="discovery">
              <h1>Natsu Matsuri</h1>
              <p>Journée Associative du WEI 2022 ! 💮</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>09/2022</time>
            <div class="discovery">
              <h1>Journée des Arts</h1>
              <p>Journée sur le thème de l'art sous toutes ses formes ! 🎨</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>09/2022</time>
            <div class="discovery">
              <h1>La Fresque Artistique</h1>
              <p>Au programme du WEI 2022 ! 💯</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>10/2022</time>
            <div class="discovery">
              <h1>Art'Ober : Edition 2022</h1>
              <p>Préparez-vous au BOO ! 👻</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>10/2022</time>
            <div class="discovery">
              <h1>Soirée éffrayante</h1>
              <p>Soirée d'Halloween en collaboration avec Efr'action ! 🎃</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>12/2022</time>
            <div class="discovery">
              <h1>Noël des Enfants 2022</h1>
              <p>Journée dédiée aux enfants des salariés d'EFREI Paris ! 🎄</p>
            </div>
          </div>
        </li>
        <div class="ligne">
          <div class="texte-ligne">2023</div>
        </div>
        <li>
          <div>
            <time>01/2023</time>
            <div class="discovery">
              <h1>Program'her</h1>
              <p>
                Programme de découverte numérique destiné aux lycéennes ! 👩
              </p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>02/2023</time>
            <div class="discovery">
              <h1>Participation au SFA 2023</h1>
              <p>
                Création des décors pour le Spectacle de Fin d'Année organisé
                par le BDA ! 🎭
              </p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>03/2023</time>
            <div class="discovery">
              <h1>Exposition à thème</h1>
              <p>Thème : Alice au Pays des Merveilles ! ✨</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>04/2023</time>
            <div class="discovery">
              <h1>Journée Internationale</h1>
              <p>
                Journée de présentation d'expérience à l'étranger par EFREI
                Paris ! 🌐
              </p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>04/2023</time>
            <div class="discovery">
              <h1>La Grande Expo'</h1>
              <p>Exposition inter-école avec le BDA ISIT ! 💞</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>05/2023</time>
            <div class="discovery">
              <h1>2ème Bureau Restreint</h1>
              <p>🔶 Président : Victor VALET 🔶</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>09/2023</time>
            <div class="discovery">
              <h1>Feria Del Tejon</h1>
              <p>Journée Associative du WEI 2023 ! 💮</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>09/2023</time>
            <div class="discovery">
              <h1>La Fresque Artistique</h1>
              <p>Au programme du WEI 2023 ! 💯</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>10/2023</time>
            <div class="discovery">
              <h1>Art'Ober : Edition 2023</h1>
              <p>Préparez-vous au BOO ! 👻</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>11/2023</time>
            <div class="discovery">
              <h1>Art'EFREI x BDA</h1>
              <p>Semaine des Arts + POD des associations artistiques ! 💥</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>12/2023</time>
            <div class="discovery">
              <h1>Noël des Enfants 2023</h1>
              <p>Journée dédiée aux enfants des salariés d'EFREI Paris ! 🎄</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>12/2023</time>
            <div class="discovery">
              <h1>Semaine de Noël x BDE</h1>
              <p>Stand avec fresque participative ! 📌</p>
            </div>
          </div>
        </li>
        <div class="ligne">
          <div class="texte-ligne">2024</div>
        </div>
        <li>
          <div>
            <time>01/2024</time>
            <div class="discovery">
              <h1>Journée du Cinéma</h1>
              <p>En partenariat avec Efr'Action ! 🎫</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>03/2024</time>
            <div class="discovery">
              <h1>Journée Internationale</h1>
              <p>Art'EFREI était de la partie ! ✌</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>03/2024</time>
            <div class="discovery">
              <h1>Participation au SFA 2024</h1>
              <p>
                Création des décors pour le Spectacle de Fin d'Année organisé
                par le BDA ! 🎭
              </p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>03/2024</time>
            <div class="discovery">
              <h1>Création du Site Web</h1>
              <p>Webmaster : Victor VALET ! 👽</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>04/2024</time>
            <div class="discovery">
              <h1>Nouveau local partagé</h1>
              <p>On remercie la Scène EFREI'née pour leur gentillesse ! 🤗</p>
            </div>
          </div>
        </li>
        <li>
          <div>
            <time>04/2024</time>
            <div class="discovery">
              <h1>3ème Bureau Restreint</h1>
              <p>🔶 Présidente : Morgane CORDIER 🔶</p>
            </div>
          </div>
        </li>
        <div class="ligne">
          <div class="texte-ligne-bis">À suivre...</div>
        </div>
        <br /><br /><br />
      </ul>
    </section>
  </div>
  <FooTer></FooTer>
</template>
    
<script>
import NavBar from "./NavBar.vue";
import FooTer from "./FooTer.vue";

export default {
  components: {
    NavBar,
    FooTer,
  },
  data() {
    return {
      showMobileMenu: false,
    };
  },
  methods: {
    showMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    showSettings() {
      // Handle the settings click event here
    },
    // Ajoutez la fonctionnalité de défilement ici
    isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    callbackFunc() {
      var items = document.querySelectorAll(".timeline li");
      for (var i = 0; i < items.length; i++) {
        if (this.isElementInViewport(items[i])) {
          if (!items[i].classList.contains("in-view")) {
            items[i].classList.add("in-view");
          }
        } else if (items[i].classList.contains("in-view")) {
          items[i].classList.remove("in-view");
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.callbackFunc);
  },
};
</script>
  
  <style lang="scss" scoped>
@font-face {
  font-family: "BebasNeue";
  src: url("@/assets/BebasNeue-Regular.woff2") format("woff2"),
    url("@/assets/BebasNeue-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Amarillo";
  src: url("@/assets/Amarillo.ttf") format("truetype");
}

$primary-color: #fff;
$background-color: #fff;
$text-color: #161fa8;

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.ligne {
  position: relative;
  margin-top: 50px;
  width: 100%;
  height: 1px; /* Épaisseur de la ligne */
  border-top: 1px dotted #ec008b; /* Ligne en pointillés */
}

.ligne::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px; /* Épaisseur des points */
  background-image: radial-gradient(
    circle,
    #ec008b 0%,
    #ec008b 50%,
    transparent 50%,
    transparent 100%
  ); /* Dégradé pour les points */
  background-size: 10px 1px; /* Taille des points */
  background-repeat: repeat-x; /* Répétition horizontale */
  transform: translateY(-50%);
}

.texte-ligne {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ec008b; /* Couleur du texte */
  font-size: 25px; /* Taille du texte */
  font-weight: bold; /* Gras */
  border: 2px solid white; /* Bordure blanche autour du texte */
  padding: 5px; /* Espace intérieur de la bordure */
  background-color: white; /* Couleur de fond de la bordure */
  z-index: 1; /* Mettre la bordure au-dessus de la ligne */
  font-family: "BebasNeue", sans-serif;
}

.texte-ligne-bis {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ec008b; /* Couleur du texte */
  font-size: 25px; /* Taille du texte */
  font-weight: bold; /* Gras */
  border: 2px solid white; /* Bordure blanche autour du texte */
  padding: 5px; /* Espace intérieur de la bordure */
  background-color: white; /* Couleur de fond de la bordure */
  z-index: 1; /* Mettre la bordure au-dessus de la ligne */
  font-family: "BebasNeue", sans-serif;
}

// STYLING
.timeline {
  ul {
    li {
      list-style-type: none;
      position: relative;
      width: 6px;
      margin: 0 auto;
      padding-top: 50px;
      background: #fff;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%) rotate(45deg);
        width: 20px;
        height: 20px;
        z-index: 2;
        background: #00adef;
      }
      div {
        position: relative;
        bottom: 0;
        width: 400px;
        padding: 20px;
        background: $primary-color;
        box-shadow: 0 5px 20px rgba(1, 1, 1, 0.2);
        border-radius: 20px;
        display: flex;
        align-items: center;
        time {
          position: absolute;
          background: #ec008b;
          color: #fff;
          width: 100px;
          height: 30px;
          top: -15px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          letter-spacing: 2px;
          font-family: "BebasNeue", sans-serif;
        }
        div {
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          p {
            text-align: center;
          }
        }
        .discovery {
          margin-right: 10px;
          h1 {
            background-color: #fef200;
            font-family: "Inter", sans-serif;
          }
          p {
            margin-top: 10px;
            font-family: "Inter", sans-serif !important;
          }
        }
      }
      &:nth-of-type(odd) {
        > div {
          left: 45px;
        }
      }
      &:nth-of-type(even) {
        > div {
          left: -439px;
        }
      }
    }
  }
}

// ANIMATION
.timeline {
  margin-top: 250px;
  ul {
    li {
      div {
        visibility: hidden;
        opacity: 0;
        transition: all 0.5s ease-in-out;
      }
      &:nth-of-type(odd) {
        div {
          transform: translate3d(100px, -10px, 0) rotate(10deg);
        }
      }
      &:nth-of-type(even) {
        div {
          transform: translate3d(-100px, -10px, 0) rotate(10deg);
        }
      }
      &.in-view {
        div {
          transform: none;
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .texte-ligne {
    left: 4%;
  }
  .texte-ligne-bis {
    left: 8%;
  }
  .timeline {
    ul {
      li {
        margin-left: 20px;
        &:nth-of-type(even) {
          > div {
            left: 45px;
          }
        }
      }
    }
  }
}

</style>